import { render, staticRenderFns } from "./FrequentAbsences.vue?vue&type=template&id=1e5be50c"
import script from "./FrequentAbsences.vue?vue&type=script&lang=js"
export * from "./FrequentAbsences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports